import { render, staticRenderFns } from "./accountModal.vue?vue&type=template&id=6b2df620&scoped=true&"
import script from "./accountModal.vue?vue&type=script&lang=js&"
export * from "./accountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2df620",
  null
  
)

export default component.exports